export const environment = {
  production: false,
  ktRootUri: "https://beta.kingtrivia.com",
  domainAppend: "beta",
  hostUri: "https://betahost.kingtrivia.com",
  playerUri: "https://betaplay.kingtrivia.com"
};
